import {
  DeployStatusOverride,
  PlanDeployStatus,
  PlanMetadataModel
} from '@core/models/plan.model';
import { isNil } from '@core/utils/shared-utils';

/** The plan's deploy statuses, each replaced by its live override when that is newer. */
export function deployStatusesOf(
  plan: PlanMetadataModel | null,
  overrides: Record<string, DeployStatusOverride>
): PlanDeployStatus[] {
  const planId = plan?.id;
  const statuses = plan?.deployStatus ?? [];
  if (isNil(planId) || Object.keys(overrides).length === 0) return statuses;

  // For the loaded plan, optimistic/live status is written straight into
  // plan.deployStatus by the reducer; this override application is the
  // staleness-guarded fallback (and is a no-op when stamps are equal).
  return statuses.map((s) => {
    const ov = overrides[`${planId}__${s.configId}`];
    const fetchedAt = s.updatedAt ? new Date(s.updatedAt).getTime() : 0;
    return ov && ov.updatedAt > fetchedAt ? { ...s, status: ov.status } : s;
  });
}
